import { TranslateFunction, translate } from '@deltasierra/i18n';
import { MemoizedFunction, memo } from '../common';

export * from '@deltasierra/i18n';

/**
 * The memoized version of the translate function
 *
 * @param key - The translation key in dot notation
 * @param [options] - Optional options object for use in translations that use variables
 * @returns The translated string
 */

export const t: MemoizedFunction<Parameters<TranslateFunction>, ReturnType<TranslateFunction>> = memo(translate);
